import './styles/Login.css';
import { FcGoogle } from "react-icons/fc";

function Login() {
    const API_URL = process.env.REACT_APP_API_URL

    const handleLogin = () => {
        window.location.href = `${API_URL}/auth/google`;
    }
    return (
        <div className="container">
            <div className="title-section">
                <h2 className="title-text">ISY Makerspace Student Tracking System</h2>
                <p className="subtitle-text">Computer Science IA Project</p>
                <div className="centered-container">
                    <div className="google-login-container">
                        <button onClick={handleLogin} className='google-login-button'>
                        <FcGoogle className='google-icon'/>
                            <span>
                                Sign in with Google
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
